import { ReactNode, useState } from "react";
import Sidebar from "./sidebar-new";  // Import our new sidebar component
import { AzureSignOutButton } from "@/components/auth/AzureAuthButtons";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { useTheme } from "@/components/theme/ThemeProvider";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { theme, toggleTheme } = useTheme();
  
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };
  
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar collapsed={sidebarCollapsed} />
      <div className="flex-1 flex flex-col overflow-hidden bg-background text-foreground">
        <header className="bg-card shadow-sm z-10">
          <div className="px-6 py-3 flex items-center justify-between">
            <div className="flex items-center">
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={toggleSidebar}
                className="mr-4"
                aria-label="Toggle sidebar"
              >
                <Menu className="h-5 w-5" />
              </Button>
              <h2 className="text-lg font-medium">Dataverse Integration Hub</h2>
            </div>
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <span className="text-xs text-gray-500 dark:text-gray-400">Dark Mode</span>
                <Switch checked={theme === "dark"} onCheckedChange={toggleTheme} />
              </div>
              <AzureSignOutButton />
            </div>
          </div>
        </header>
        <main className="flex-1 overflow-y-auto bg-background text-foreground">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
